import { render, staticRenderFns } from "./subject-from.vue?vue&type=template&id=64979602&scoped=true"
import script from "./subject-from.vue?vue&type=script&lang=js"
export * from "./subject-from.vue?vue&type=script&lang=js"
import style0 from "./subject-from.vue?vue&type=style&index=0&id=64979602&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64979602",
  null
  
)

export default component.exports